import React from 'react'

import Parameter from './Parameter'

import style from './Parameters.module.scss'
import { withMicrocopy } from '~contexts/MicrocopyContext'

const Parameters = ({ 
  params, 
  hideExtras, 
  parent,
  explorer,
  microcopy
}) => (
  <>
    { params?.[0] && (
      <section className={ style.list }>
        { params.map(param => (
          <Parameter 
            key={param.id} 
            param={param}
            parent={parent}
            explorer={explorer}
            microcopy={microcopy}
            hideExtras={ hideExtras } />
        ))}
      </section>
    )}
  </>
)

export default withMicrocopy(Parameters)
